module.exports = __webpack_public_path__ + "static/about-insta-4@2x-57f508017b2dc3f9c6896bc37f694fba.jpg";